import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-redirect',
  template: '<div>Redirecting...</div>',
})
export class RedirectComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe(params => {
      switch (params.get('mode')) {
        case 'resetPassword':
          void this.router.navigate([ '/auth/reset-password' ], { queryParamsHandling: 'merge' });
          break;
        case 'verifyEmail':
          void this.router.navigate([ '/auth/verify-email' ], { queryParamsHandling: 'merge' });
          break;
      }
    });
  }
}
